<template>
  <div class="detail-pengajuan-card">
    <h3 class="section-title">Detail Pengajuan</h3>

    <div class="detail-row">
      <span class="detail-label">Pengaju Surat</span>
      <span class="detail-value">
        {{ creatorName }} ({{ formatRole(creatorRole) }})
      </span>
    </div>

    <div class="detail-row">
      <span class="detail-label">Waktu Dibuat/Unggah</span>
      <span class="detail-value">{{ formattedDateTime }}</span>
    </div>

    <div class="detail-row">
      <span class="detail-label">Verifikator</span>
      <span class="detail-value">{{ verifikatorFlow }}</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import moment from 'moment'
import 'moment/locale/id'

moment.locale('id')

export default defineComponent({
  name: 'DetailPengajuan',
  props: {
    creator: {
      type: Object,
      default: null,
    },
    createdAt: {
      type: String,
      default: null,
    },
    verifikator: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const store = useStore()

    const creatorName = computed(() => props.creator?.name || '-')
    const creatorRole = computed(() => props.creator?.role || null)

    const formatRole = (role) => {
      return store.getters['suratKeluar/formatRole'](role)
    }

    const formattedDateTime = computed(() => {
      if (!props.createdAt) return '-'
      return moment(props.createdAt).format('dddd YYYY-MM-DD HH:mm')
    })

    // Format verifikator list with approval status
    const verifikatorFlow = computed(() => {
      if (!props.verifikator || props.verifikator.length === 0) return '-'

      // Sort by urutan first (ascending)
      const sortedVerifikator = [...props.verifikator].sort((a, b) => {
        const urutanA = a.urutan || 0
        const urutanB = b.urutan || 0
        return urutanA - urutanB
      })

      return sortedVerifikator
        .map((v, index) => {
          const name = v.user?.name || 'Unknown'
          let statusText = ''

          if (v.status === 'approved') {
            statusText = '(Setuju)'
          } else if (v.status === 'revised' || v.status === 'revision_requested') {
            statusText = '(Revisi)'
          } else if (v.status === 'pending') {
            // Check if all previous verifikators are approved
            const allPreviousApproved = sortedVerifikator
              .slice(0, index)
              .every(prev => prev.status === 'approved')

            if (allPreviousApproved) {
              statusText = '(Sedang Verifikasi)'
            } else {
              statusText = '(Menunggu)'
            }
          }
          return `${name} ${statusText}`
        })
        .join(' → ')
    })

    return {
      creatorName,
      creatorRole,
      formatRole,
      formattedDateTime,
      verifikatorFlow,
    }
  },
})
</script>

<style lang="scss" scoped>
.detail-pengajuan-card {
  background: white;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
    margin: 0 0 16px 0;
  }

  .detail-row {
    display: flex;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .detail-label {
      width: 180px;
      flex-shrink: 0;
      color: #8c8c8c;
      font-size: 14px;
    }

    .detail-value {
      flex: 1;
      color: #262626;
      font-size: 14px;
    }
  }
}
</style>
